module.exports = __webpack_public_path__ + "img/service-sec02-img01.2ee10843.png";